import React from "react";
import { motion } from "framer-motion";

import {
  MessageCircle,
} from "lucide-react";

export default function FloatingWhatsApp() {

  // WhatsApp Link

  const href =
    "https://wa.me/917075392825";

  return (
    <>
      <style>
        {`
          .whatsapp-ring::before {
            content: "";
            position: absolute;
            inset: -10px;
            border-radius: 9999px;

            background:
              radial-gradient(
                circle,
                rgba(168, 85, 247, 0.18),
                rgba(168, 85, 247, 0)
              );

            animation: pulseRing 2.6s infinite;

            z-index: -2;
          }

          .whatsapp-ring::after {
            content: "";
            position: absolute;
            inset: -18px;
            border-radius: 9999px;

            border: 1px solid rgba(168, 85, 247, 0.12);

            animation: softPulse 3s infinite;

            z-index: -3;
          }

          @keyframes pulseRing {
            0% {
              transform: scale(0.9);
              opacity: 0.7;
            }

            70% {
              transform: scale(1.45);
              opacity: 0;
            }

            100% {
              transform: scale(1.45);
              opacity: 0;
            }
          }

          @keyframes softPulse {
            0% {
              transform: scale(1);
              opacity: 0.5;
            }

            50% {
              transform: scale(1.08);
              opacity: 0.12;
            }

            100% {
              transform: scale(1);
              opacity: 0.5;
            }
          }

          @keyframes floatWhatsapp {
            0% {
              transform: translateY(0px);
            }

            50% {
              transform: translateY(-6px);
            }

            100% {
              transform: translateY(0px);
            }
          }

          .floating-whatsapp {
            animation: floatWhatsapp 4s ease-in-out infinite;
          }
        `}
      </style>

      <motion.a
        href={href}

        target="_blank"
        rel="noopener noreferrer"

        aria-label="Chat on WhatsApp"

        data-testid="floating-whatsapp-btn"

        className="
          whatsapp-ring
          floating-whatsapp

          fixed

          bottom-4
          right-4

          sm:bottom-6
          sm:right-6

          z-50

          w-14 h-14
          sm:w-16 sm:h-16

          rounded-full

          flex items-center justify-center

          backdrop-blur-xl

          border border-white/20

          overflow-hidden

          transition-all duration-300
        "

        style={{
          background:
            "linear-gradient(135deg, #6D3B8C 0%, #9B4D96 45%, #25D366 100%)",

          boxShadow:
            `
              0 20px 50px rgba(109, 59, 140, 0.28),
              0 10px 25px rgba(37, 211, 102, 0.22)
            `,
        }}

        initial={{
          scale: 0,
          rotate: -90,
          opacity: 0,
        }}

        animate={{
          scale: 1,
          rotate: 0,
          opacity: 1,
        }}

        transition={{
          delay: 1,
          type: "spring",
          stiffness: 220,
          damping: 18,
        }}

        whileHover={{
          scale: 1.08,
          y: -4,
        }}

        whileTap={{
          scale: 0.92,
        }}
      >
        {/* GLOSS EFFECT */}

        <div
          className="
            absolute inset-0

            bg-gradient-to-b
            from-white/20
            to-transparent

            pointer-events-none
          "
        />

        {/* SHINE EFFECT */}

        <div
          className="
            absolute inset-0

            opacity-40

            bg-[linear-gradient(120deg,transparent,rgba(255,255,255,0.5),transparent)]

            translate-x-[-100%]

            animate-[shine_5s_linear_infinite]
          "
        />

        {/* ICON */}

        <MessageCircle
          className="
            relative z-10

            w-7 h-7
            sm:w-8 sm:h-8

            text-white

            drop-shadow-[0_2px_6px_rgba(0,0,0,0.25)]
          "
        />
      </motion.a>
    </>
  );
}